import { useContext, useSyncExternalStore } from 'react';
import memoize from '../lib/memoize';
import { ABTestStoreContext } from './components/ABTestStoreProvider';
import emitter from './emitter';
import { getActiveVariant } from './utils';
export const useABTestStore = () => useContext(ABTestStoreContext);
const subscribe = memoize((name) => (onStoreChange) => {
    const handler = (experimentName) => {
        if (name === experimentName) {
            onStoreChange();
        }
    };
    emitter.addListener('active-variant', handler);
    return () => {
        emitter.removeListener('active-variant', handler);
    };
});
const getSnapshot = memoize((name) => () => getActiveVariant(name));
/**
 * Returns the active variant of an experiment
 *
 * Since it will be called multiple times in different places, we memoize the `subscribe` and `getSnapshot` function based on the experiment name
 */
export const useActiveVariant = (name) => {
    return useSyncExternalStore(subscribe(name), getSnapshot(name));
};
